export const EVENT_CLICK = "click";
/** @deprecated (use EVENT_CLICK) */
export const CLICK_EVENT = EVENT_CLICK;
export const EVENT_INPUT = "input";
export const EVENT_KEYDOWN = "keydown";
export const EVENT_SUBMIT = "submit";
export const EVENT_HASHCHANGE = "hashchange";
export const EVENT_POPSTATE = "popstate";
export const EVENT_ANIMATIONEND = "animationend";
export const EVENT_TRANSITIONEND = "transitionend";
export function on(target, type, listener, options) {
    if (Array.isArray(type)) {
        for (const t of type) {
            target.addEventListener(t, listener, options);
        }
    }
    else {
        target.addEventListener(type, listener, options);
    }
}
export const off = (target, type, listener, options) => {
    if (!listener) {
        return;
    }
    if (Array.isArray(type)) {
        for (const t of type) {
            target.removeEventListener(t, listener, options);
        }
    }
    else {
        target.removeEventListener(type, listener, options);
    }
};
export const trigger = (target, type, detail, bubbles = true) => {
    return target.dispatchEvent(new CustomEvent(type, { detail, bubbles, cancelable: bubbles }));
};
export const onClick = (element, listener, options) => {
    element.addEventListener("click", listener, options);
};
export const onWindow = (type, listener, options) => {
    on(window, type, listener, options);
};
export const getEventTarget = (evt) => evt.target;
